<template>
    <div class="h-full w-full flex flex-col">
        <div id="loading-overlay" class="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50"
            v-if="isGenerateReport">
            <img src="../../assets/images/loading_spinner/1.gif" alt="Loading...">
        </div>
        <div class="h-full container mx-auto">
            <div class="px-4 sm:px-8 flex flex-col h-full w-full py-4 sm:py-8">
                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <div class="flex items-center text-sm font-light">
                        <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
                        <span class="mx-2">/</span>
                        <router-link to="/sponsorship-management"
                            class="opacity-50 hover:opacity-100">Sponsorship</router-link>
                        <span class="mx-2">/</span>
                        <span>Sponsors List</span>
                    </div>
                    <div class="font-bold">Sponsors List</div>
                </div>

                <!-- Sponsorship Dashboard Start -->
                <div class="flex flex-col mt-8">
                    <div class="grid grid-col-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-8">
                        <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">Total</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">{{ totalAlumni }}</h1>
                                </div>
                            </div>
                        </div>
                        <!-- <div v-if="isShowChart('ATHS', atsTotalAlumni)" class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">ATS</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">{{ atsTotalAlumni }}</h1>
                                </div>
                                <div class="flex-shrink-0">
                                    <img class="h-8" src="../../assets/images/dashboard/alumni/ATS.png" alt="ATS">
                                </div>
                            </div>
                        </div> -->
                        <div v-if="isShowChart('ADPOLY', adpolyTotalAlumni)"
                            class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">ADPOLY</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">{{ adpolyTotalAlumni }}</h1>
                                </div>
                                <div class="flex-shrink-0">
                                    <img class="h-12" src="../../assets/images/dashboard/alumni/ADPOLY.png"
                                        alt="ADPOLY">
                                </div>
                            </div>
                        </div>
                        <div v-if="isShowChart('FCHS', fchsTotalAlumni)"
                            class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">FCHS</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">{{ fchsTotalAlumni }}</h1>
                                </div>
                                <div class="flex-shrink-0">
                                    <img class="h-14" src="../../assets/images/dashboard/alumni/FCHS.png" alt="FCHS">
                                </div>
                            </div>
                        </div>
                        <div v-if="isShowChart('ADVETI', advetiTotalAlumni)"
                            class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">ADVETI</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">{{ advetiTotalAlumni }}</h1>
                                </div>
                                <div class="flex-shrink-0">
                                    <img class="h-16" src="../../assets/images/dashboard/alumni/ADVETI.png"
                                        alt="ADVETI">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-8 mt-8">
                        <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <h1 class="text-lg font-bold">Sponsorship / Entity</h1>
                            <div v-if="isDashboardLoading" class="wd-380 ht-242-7 flex items-center">
                                <div class="">
                                    <div class="ml-8 wd-216 ht-216 rounded-full bg-gray-200 animate-pulse"></div>
                                </div>
                            </div>
                            <apexchart v-else type="pie" width="380" :options="chartOptions1" :series="series1">
                            </apexchart>
                        </div>
                    </div>

                </div>
                <!-- Sponsorship Dashboard End -->

                <div class="mt-8 flex justify-end items-center">
                    <div v-if="isExportExcel"
                        class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg hover:text-ternary text-white">
                        <base-spinner-with-text class-list="w-4 h-4" text=""
                            text-class-list="text-white"></base-spinner-with-text>
                        <span class="text-xs">Exporting Excel</span>
                    </div>
                    <div v-else @click="generateReport"
                        class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg cursor-pointer hover:text-ternary text-white">
                        <font-awesome-icon :icon="['fas', 'file-excel']" />
                        <span class="text-xs ml-2">Export Excel</span>
                    </div>
                </div>

                <section class="mt-8 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex justify-end flex-wrap">
                        <!-- <h1 class="text-base md:text-lg font-semibold text-ternary">Students List</h1> -->
                        <div class="flex justify-start items-center flex-wrap w-full">

                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Entity:</div>
                                <select v-model="filterByEntity" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option :value="item.entity" v-for="(item, index) in filteredEntities" :key="index">
                                        {{ getEntityName(item.entity) }}</option>
                                </select>
                            </div>

                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Campus:</div>
                                <select v-model="filterByCampus" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option :value="c.campus_code" v-for="(c, index) in filteredCampuses" :key="index">
                                        {{ c.campus_code }}</option>
                                </select>
                            </div>

                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Sponsor:</div>
                                <select v-model="filterBySponsor" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option :value="item" v-for="(item, index) in sponsorsList" :key="index">{{ item }}
                                    </option>
                                </select>
                            </div>

                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Local or Non Local:</div>
                                <select v-model="filterByLocalOrNonLocal" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="Local">Local</option>
                                    <option value="Non Local">Non Local</option>
                                </select>
                            </div>

                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Academic Year:</div>
                                <select v-model="filterByAcademicYears" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option :value="item" v-for="(item, index) in academicYearsList" :key="index">{{
                                        item }}</option>
                                </select>
                            </div>

                            <div
                                class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">{{ getSpecializationTitle }}:</div>
                                <select v-model="filterBySpecialization" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option :value="item" v-for="(item, index) in specializationsList" :key="index">{{
                                        item }}</option>
                                </select>
                            </div>

                            <!-- <div class="w-full sm:w-auto mr-0 sm:mr-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Status:</div>
                                <select v-model="filterByStatus" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option :value="ss.code" v-for="(ss, index) in studentStatusList" :key="index">{{ ss.name }}</option>
                                </select>
                            </div> -->

                            <div class="w-full sm:w-auto mb-4">
                                <search @on-search="onSearch" class-list="px-4 h-8"></search>
                            </div>

                        </div>
                    </div>

                    <div class="flex justify-start">
                        <div @click.stop="clearAllFilter()"
                            class="px-3 py-1 text-sm border border-red-500 bg-red-500 hover:bg-white text-white hover:text-red-500 rounded-lg cursor-pointer">
                            Clear All Filter</div>
                    </div>

                    <div class="flex flex-col" v-if="$apollo.queries.sponsors_list.loading">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <div class="min-w-full text-left text-sm font-light">
                                        <div class="border-b font-medium dark:border-neutral-500">
                                            <div class="flex">
                                                <div class="px-6 py-2 text-gray-400 w-12 lg:w-16">#</div>
                                                <div class="flex-grow px-6 py-2 text-gray-400">
                                                    <div class="w-32 md:w-auto">Name</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Entity</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Sponsor</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">{{ getSpecializationTitle }}</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Academic Year</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400 w-24 lg:w-40">Actions</div>
                                            </div>
                                        </div>
                                        <div>
                                            <student-tile-shimmer v-for="(sts, index) in first"
                                                :key="index"></student-tile-shimmer>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="noItems" class="h-full flex justify-center items-center">
                        <h1 class="text-center text-xl font-medium">No sponsorship users found!</h1>
                    </div>
                    <div v-else class="flex flex-col">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <table class="min-w-full text-left text-sm font-light">
                                        <thead class="border-b font-medium dark:border-neutral-500">
                                            <tr>
                                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Name</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Entity</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Sponsor</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">{{
                                                    getSpecializationTitle }}</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Employer</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Academic Year</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(student, index) in filteredStudents" :key="index"
                                                class="border-b border-dashed dark:border-neutral-500">
                                                <td class="whitespace-nowrap px-6 py-2 font-medium">{{
                                                    paginatorInfo.firstItem + index }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    <div class="flex items-center">
                                                        <div class="flex-shrink-0 mr-3">
                                                            <img @click.stop="openPreviewImgModal(student.student_id, student.entity)"
                                                                class="h-12 w-12 rounded-lg object-cover cursor-pointer"
                                                                :src="getProfilePicture(student.student_id, student.entity)"
                                                                alt="">
                                                        </div>
                                                        <div class="flex-grow flex flex-col">
                                                            <h1 class="text-sm font-semibold flex items-center">
                                                                <span
                                                                    @click.stop="viewStudentProfile(student.student_id)"
                                                                    class="text-heading hover:text-blue-600 hover:underline cursor-pointer">{{
                                                                        student.name_en }}</span>
                                                            </h1>
                                                            <p class="text-xs text-gray-400">{{ student.name_ar }}</p>
                                                            <p class="text-xs text-gray-400">{{ student.student_id }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ getEntityName(student.entity)
                                                }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ student.sponsor }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    getSpecialization(student.entity, student.study_program,
                                                        student.program_name, student.program_code, student.cluster_e) }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    student.sponsoredStudentEmploymentDetails ?
                                                        student.sponsoredStudentEmploymentDetails.employer : '' }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    getAcademicYear(student.academic_year, student.ay) }}</td>
                                                <td class="px-6 py-2">
                                                    <div class="flex">
                                                        <div v-if="hasPermission('students-show')"
                                                            @click.stop="viewStudentProfile(student.student_id)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-eye
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                                        </div>
                                                        <div v-if="hasPermission('students-show')"
                                                            @click.stop="generatePdf(student.student_id)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-printer
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-printer>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                        </div>
                    </div>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="previewImageModal" title="" height="50vh" @close="closePreviewImageModal">
                            <img class="h-full w-full object-contain" :src="previewImg" />
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-full-modal v-if="showStudentProfileFullModal" title="Student Profile"
                            @close="closeFullModal">
                            <student-profile :student-id="studentId"></student-profile>
                        </base-full-modal>
                    </transition>

                </section>
            </div>
        </div>
        <div class="h-full flex justify-center items-center" v-if="isExportExcel">
            <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
        </div>
    </div>
</template>
<script>
import IconEye from "../../components/icons/IconEye.vue";
import IconPrinter from "../../components/icons/IconPrinter.vue";
import gql from 'graphql-tag';
import Pagination from "../../components/shared/pagination.vue";
import StudentTileShimmer from '../../components/students/StudentTileShimmer.vue';
import Search from "../../components/shared/search.vue";
import StudentProfile from "../student-profile/index.vue";
import xlsx from "xlsx/dist/xlsx.full.min.js";
export default {
    name: "sponsorship-index",
    components: {
        IconEye,
        IconPrinter,
        Pagination,
        StudentTileShimmer,
        Search,
        StudentProfile,
    },
    data() {
        return {
            sponsors_list: [],
            first: 10,
            page: 1,
            openviewStudentModal: false,
            studentId: null,
            searchText: "",
            filterByEntity: "",
            filterByCampus: "",
            filterBySponsor: "",
            filterByLocalOrNonLocal: "",
            filterByAcademicYears: "",
            filterBySpecialization: "",
            filterByStatus: "AS",
            studentStatusList: [],
            previewImageModal: false,
            previewImg: "",
            isGenerateReport: false,
            entities: [],
            showStudentProfileFullModal: false,
            isDashboardLoading: false,
            totalAlumni: 0,
            atsTotalAlumni: 0,
            adpolyTotalAlumni: 0,
            fchsTotalAlumni: 0,
            advetiTotalAlumni: 0,
            academicYearsList: [],
            sponsorsList: [],
            specializationsList: [],
            campusList: [],
            isExportExcel: false,
            isApiCallRecurisive: false,
            generatedReport: [],
        };
    },
    created() {
        this.getAcademicYears();
        this.getSpecializations();
        this.getCampusList();
        this.getSponsorsList();
        this.getSponsorshipDashboard();
    },
    watch: {
        searchText() {
            this.page = 1;
        },
        filterByEntity() {
            this.clearAllFilter('filterByEntity');
            this.page = 1;
            this.getAcademicYears();
            this.getSpecializations();
            this.getSponsorsList();
            this.getSponsorshipDashboard();
        },
        filterByAcademicYears() {
            this.page = 1;
            this.filterBySpecialization = "";
            this.getSpecializations();
            this.getSponsorshipDashboard();
        },
        filterBySpecialization() {
            this.page = 1;
            this.getSponsorshipDashboard();
        },
        filterByCampus() {
            this.page = 1;
            this.getSponsorshipDashboard();
        },
        filterBySponsor() {
            this.page = 1;
            this.getSponsorshipDashboard();
        },
        filterByLocalOrNonLocal() {
            this.page = 1;
            this.getSponsorshipDashboard();
        },
    },
    computed: {
        getSpecializationTitle() {
            if (this.filterByEntity == 'ATHS' || this.filterByEntity == 'ATS') {
                return "Cluster";
            } else {
                return "Program";
            }
        },
        noItems() {
            if (!this.$apollo.queries.sponsors_list.loading && this.filteredStudents.length <= 0) {
                return true;
            } else {
                return false;
            }
        },
        filteredCampuses() {
            if (this.filterByEntity) {
                return this.campusList.filter(campus => campus.entity === this.filterByEntity);
            } else {
                return this.campusList;
            }
        },
        filteredStudents() {
            return this.sponsors_list.data;
        },
        paginatorInfo() {
            return this.sponsors_list.paginatorInfo;
        },
        role() {
            return this.$store.getters.role;
        },
        userEntities() {
            return this.$store.getters.entity;
        },
        filteredEntities() {
            if (this.entities.data && this.entities.data.length > 0) {
                const entitiesToRemove = ["ATHS", "ATS"];
                const filteredList = this.entities.data.filter(item => !entitiesToRemove.includes(item.entity));
                return filteredList;
            } else {
                return [];
            }
        },
        series1() {
            if (this.filterByEntity == 'ADPOLY') {
                return [this.adpolyTotalAlumni];
            } else if (this.filterByEntity == 'FCHS') {
                return [this.fchsTotalAlumni];
            } else if (this.filterByEntity == 'ADVETI') {
                return [this.advetiTotalAlumni];
            } else {
                let count = [];
                if (this.adpolyTotalAlumni > 0) {
                    count.push(this.adpolyTotalAlumni);
                }
                if (this.fchsTotalAlumni > 0) {
                    count.push(this.fchsTotalAlumni);
                }
                if (this.advetiTotalAlumni > 0) {
                    count.push(this.advetiTotalAlumni);
                }
                return count;
            }
        },
        chartOptions1() {
            const labels = this.getLabelBasedOnEntity();
            return {
                chart: {
                    width: 380,
                    type: 'pie',
                },
                labels: labels,
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }
                ]
            }
        },
    },
    apollo: {
        entities() {
            return {
                query: gql`query GetEntityList {
                    entities {
                        data {
                            entity
                        }
                    }
                }`,
                fetchPolicy: 'cache-and-network',
            }
        },
        studentStatusList() {
            return {
                query: gql`query GetStudentStatusList {
                    studentStatusList(is_show: "1") {
                        code
                        name
                    }
                }`
            }
        },
        sponsors_list() {
            return {
                query: gql`query GetAllSponsorStudents($first: Int!, $page: Int!, $search: String, $entity: String, $academic_year: String, $campus_code: String, $sponsor: String, $local_or_non_local: String, $specialization: String, $student_status: String) {
                    sponsors_list(first: $first, page: $page, search: $search, entity: $entity, academic_year: $academic_year, campus_code: $campus_code, sponsor: $sponsor, local_or_non_local: $local_or_non_local, specialization: $specialization, student_status: $student_status) {
                        data {
                            name_ar
                            name_en
                            student_id
                            entity
                            program_code
                            program_name
                            study_program
                            cluster_e
                            academic_year
                            ay
                            sponsor
                            sponsoredStudentEmploymentDetails {
                                employer
                            }
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }`,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        search: this.searchText,
                        entity: this.filterByEntity,
                        campus_code: this.filterByCampus,
                        sponsor: this.filterBySponsor,
                        local_or_non_local: this.filterByLocalOrNonLocal,
                        academic_year: this.filterByAcademicYears,
                        specialization: this.filterBySpecialization,
                        student_status: this.filterByStatus,
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        clearAllFilter(filterName = '') {
            if (!filterName) {
                this.filterByEntity = "";
            }
            this.filterByCampus = "";
            this.filterBySponsor = "";
            this.filterByLocalOrNonLocal = "";
            this.filterByAcademicYears = "";
            this.filterBySpecialization = "";
        },
        async getSponsorsList() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                            query GetSponsorsList($student_status: String, $entity: String) {
                                getSponsorsList(student_status: $student_status, entity: $entity)
                            }
                        `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                    },
                    fetchPolicy: 'network-only',
                });
                this.sponsorsList = data.getSponsorsList;
            } catch (error) {
                console.log(error);
            }
        },
        async getAcademicYears() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                            query GetAcademicYears($student_status: String, $entity: String) {
                                getAcademicYears(student_status: $student_status, entity: $entity)
                            }
                        `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                    },
                    fetchPolicy: 'network-only',
                });
                this.academicYearsList = data.getAcademicYears;
            } catch (error) {
                console.log(error);
            }
        },
        async getSpecializations() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                            query GetSpecializations($student_status: String, $entity: String, $academic_year: [String]) {
                                getSpecializations(student_status: $student_status, entity: $entity, academic_year: $academic_year)
                            }
                        `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                        academic_year: this.filterByAcademicYears ? [this.filterByAcademicYears] : [],
                    },
                });
                this.specializationsList = data.getSpecializations;
            } catch (error) {
                console.log(error);
            }
        },
        async getCampusList() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                            query GetCampusList($student_status: String, $entity: String) {
                                getCampusList(student_status: $student_status, entity: $entity) {
                                    entity
                                    campus_code
                                }
                            }
                        `,
                    variables: {
                        student_status: this.filterByStatus,
                        entity: this.filterByEntity,
                    },
                    fetchPolicy: 'network-only',
                });
                this.campusList = data.getCampusList;
            } catch (error) {
                console.log(error);
            }
        },
        getLabelBasedOnEntity() {
            if (this.filterByEntity == 'ADPOLY') {
                return ['ADPOLY'];
            } else if (this.filterByEntity == 'FCHS') {
                return ['FCHS'];
            } else if (this.filterByEntity == 'ADVETI') {
                return ['ADVETI'];
            } else {
                let labesls = [];
                if (this.adpolyTotalAlumni > 0) {
                    labesls.push('ADPOLY');
                }
                if (this.fchsTotalAlumni > 0) {
                    labesls.push('FCHS');
                }
                if (this.advetiTotalAlumni > 0) {
                    labesls.push('ADVETI');
                }
                return labesls;
            }
        },
        async getSponsorshipDashboard() {
            this.isDashboardLoading = true;
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                        query GetSponsorshipDashboard($entity: String, $campus_code: String, $sponsor: String, $local_or_non_local: String, $academic_year: String, $specialization: String, $student_status: String) {
                            getSponsorshipDashboard(entity: $entity, campus_code: $campus_code, sponsor: $sponsor, local_or_non_local: $local_or_non_local, academic_year: $academic_year, specialization: $specialization, student_status: $student_status) {
                                data {
                                    total_alumni
                                    ats_total_alumni
                                    adpoly_total_alumni
                                    fchs_total_alumni
                                    adveti_total_alumni
                                }
                            }
                        }
                    `,
                    variables: {
                        entity: this.filterByEntity,
                        campus_code: this.filterByCampus,
                        sponsor: this.filterBySponsor,
                        local_or_non_local: this.filterByLocalOrNonLocal,
                        academic_year: this.filterByAcademicYears,
                        specialization: this.filterBySpecialization,
                        student_status: this.filterByStatus,
                    },
                    fetchPolicy: 'network-only',
                });

                const alumniDashboardData = data.getSponsorshipDashboard.data;

                this.totalAlumni = alumniDashboardData.total_alumni;
                this.atsTotalAlumni = alumniDashboardData.ats_total_alumni;
                this.adpolyTotalAlumni = alumniDashboardData.adpoly_total_alumni;
                this.fchsTotalAlumni = alumniDashboardData.fchs_total_alumni;
                this.advetiTotalAlumni = alumniDashboardData.adveti_total_alumni;
            } catch (error) {
                console.log(error);
            }
            this.isDashboardLoading = false;
        },
        getEntityName(entity) {
            if (entity == 'ATHS') {
                return "ATS";
            } else {
                return entity;
            }
        },
        getSpecialization(entity, studyProgram, programName, programCode, clusterE) {
            let specialization = "";
            if (entity == 'ATHS') {
                if (clusterE) {
                    specialization = clusterE;
                } else if (programName) {
                    specialization = programName;
                } else if (studyProgram) {
                    specialization = studyProgram;
                } else {
                    specialization = programCode;
                }
            } else {
                if (programName) {
                    specialization = programName;
                } else if (studyProgram) {
                    specialization = studyProgram;
                } else {
                    specialization = programCode;
                }
            }
            return specialization;
        },
        getAcademicYear(academicYear, AY) {
            if (academicYear) {
                return academicYear;
            } else if (AY) {
                return AY;
            } else {
                return "";
            }
        },
        isShowChart(entity, count) {
            if (this.filterByEntity == "") {
                if (count == 0) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return this.filterByEntity == entity;
            }
        },
        setPage(page) {
            this.page = page;
        },
        getProfilePicture(studentId, entity) {
            return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
        },
        onSearch(searchText) {
            this.searchText = searchText;
        },
        openPreviewImgModal(studentId, entity) {
            this.previewImageModal = true;
            this.previewImg = `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
        },
        closePreviewImageModal() {
            this.previewImageModal = false;
            this.previewImg = "";
        },
        hasPermission(crudName) {
            if (this.role == 'superadmin') {
                return true;
            } else {
                const permissions = this.$store.getters.permissions;
                const permissionsArray = permissions.split(",");
                if (permissionsArray.includes(crudName)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        closeFullModal() {
            this.showStudentProfileFullModal = false;
            this.studentId = null;
        },
        viewStudentProfile(studentId) {
            this.studentId = studentId;
            this.showStudentProfileFullModal = true;
        },
        async generatePdf(studentId) {

            document.body.classList.add('loading');
            this.isGenerateReport = true;

            const GENERATE_PDF_MUTATION = gql`
                mutation GeneratePdfStudentProfile($student_id: String, $name: String!) {
                    generatePdf(student_id: $student_id, name: $name) {
                        error
                        error_code
                        message
                        url
                    }
                }
            `;

            let error_msg = "";
            let redirect_url = "";

            try {
                await this.$apollo.mutate({
                    mutation: GENERATE_PDF_MUTATION,
                    variables: {
                        student_id: studentId,
                        name: 'student-information',
                    }
                }).then((data) => {
                    if (data.data.generatePdf.error) {
                        error_msg = data.data.generatePdf.message;
                    } else {
                        redirect_url = data.data.generatePdf.url;
                    }
                }).catch((error) => {
                    error_msg = error;
                })
            } catch (error) {
                error_msg = error.message || "Failed to authenticate, try later.";
            }

            if (error_msg) {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error_msg,
                }).then((result) => {
                    console.log(result)
                })
            } else {
                const url = process.env.VUE_APP_PUBLIC_URL + redirect_url;
                window.open(url, "_blank");
            }

            this.isGenerateReport = false;
            document.body.classList.add('loading');
        },
        async generateReport() {
            var page = 1;
            var limit = 200;
            this.isExportExcel = true;
            this.isApiCallRecurisive = true;

            try {
                while (this.isApiCallRecurisive) {
                    try {
                        const responseData = await this.fetchForExporting(page, limit);

                        if (responseData.data && responseData.data.length > 0) {
                            this.generatedReport.push(
                                ...responseData.data.map((obj) => {
                                    return {
                                        student_id: obj.student_id,
                                        eid: obj.eid,
                                        name_en: obj.name_en,
                                        name_ar: obj.name_ar,
                                        entity: this.getEntityName(obj.entity),
                                        campus: obj.campus_code,
                                        program_name: this.getSpecialization(obj.entity, obj.study_program, obj.program_name, obj.program_code, obj.cluster_e),
                                        alumni_phone: obj.alumni_phone || "",
                                        primary_phone: obj.primary_phone || "",
                                        secondary_phone: obj.secondary_phone || "",
                                        primary_email: obj.primary_email || "",
                                        secondary_email: obj.secondary_email || "",
                                        local_or_non_local: obj.local_or_non_local,
                                        academic_year: this.getAcademicYear(obj.academic_year, obj.ay),
                                        registered: this.isRegistered(obj.user_id),
                                        sponsor: obj.sponsor,
                                        employer: obj.sponsoredStudentEmploymentDetails ?
                                            obj.sponsoredStudentEmploymentDetails.employer : '',
                                        updated_at: obj.updated_at,
                                    };
                                })
                            );
                            page++;
                        } else {
                            this.isApiCallRecurisive = false;
                            break;
                        }
                    } catch (error) {
                        console.error(`Error fetching page ${page}:`, error);

                        // Show error to user but continue with partial data
                        this.$swal.fire({
                            icon: 'warning',
                            title: 'Export Warning',
                            text: `Error occurred while fetching page ${page}. Exporting partial data.`,
                            timer: 3000,
                            showConfirmButton: false
                        });

                        this.isApiCallRecurisive = false;
                        break;
                    }
                }

                if (this.generatedReport.length > 0) {
                    this.exportToExcel("Sponsorship_Students");
                } else {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Export Failed',
                        text: 'No data available for export.',
                    });
                }
            } catch (error) {
                console.error('Error in generateReport:', error);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Export Failed',
                    text: 'An error occurred while generating the report.',
                });
            } finally {
                this.isExportExcel = false;
                this.isApiCallRecurisive = false;
            }
        },
        async fetchForExporting(pageNo = 1, limitSize = 50) {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                    query GenerateSponsorStudentsReport(
                        $page: Int
                        $limit: Int
                        $entity: String
                        $campus: String
                        $sponsor: String
                        $local_or_non_local: String
                        $academic_year: String
                        $specialization: String
                        $search: String
                        $student_status: String
                        $is_sponsor: String
                    ) {
                    generateStudentsReport(
                        page: $page
                        limit: $limit
                        entity: $entity
                        campus: $campus
                        sponsor: $sponsor
                        local_or_non_local: $local_or_non_local
                        academic_year: $academic_year
                        specialization: $specialization
                        search: $search
                        student_status: $student_status
                        is_sponsor: $is_sponsor
                    ) {
                        error
                        error_code
                        message
                        data {
                            student_id
                            user_id
                            eid
                            name_en
                            name_ar
                            entity
                            campus_code
                            program_name
                            study_program
                            program_code
                            cluster_e
                            primary_email
                            secondary_email
                            alumni_phone
                            primary_phone
                            secondary_phone
                            local_or_non_local
                            academic_year
                            ay
                            sponsor
                            sponsoredStudentEmploymentDetails {
                                employer
                            }
                            updated_at
                        }
                    }
                    }
                `,
                    fetchPolicy: "network-only",
                    errorPolicy: 'all', // Continue on GraphQL errors
                    variables: {
                        page: pageNo,
                        limit: limitSize,
                        entity: this.filterByEntity,
                        campus: this.filterByCampus,
                        sponsor: this.sponsor,
                        local_or_non_local: this.filterByLocalOrNonLocal,
                        academic_year: this.filterByAcademicYears,
                        specialization: this.filterBySpecialization,
                        search: this.searchText,
                        student_status: this.filterByStatus,
                        is_sponsor: "1",
                    },
                });

                const responseData = data.generateStudentsReport;

                // Check for errors in the response
                if (responseData.error) {
                    throw new Error(responseData.message || 'Server error occurred');
                }

                return responseData;
            } catch (error) {
                console.error('Error fetching data for export:', error);
                throw error; // Re-throw to handle in calling method
            }
        },
        exportToExcel(reportName) {
            const XLSX = xlsx;

            const header = [
                "STUDENT ID",
                "EID",
                "NAME IN ENGLISH",
                "NAME IN ARABIC",
                "ENTITY",
                "CAMPUS",
                "PROGRAM NAME",
                "ALUMNI PHONE",
                "PRIMARY PHONE",
                "SECONDARY PHONE",
                "PRIMARY EMAIL",
                "SECONDARY EMAIL",
                "LOCAL OR NON LOCAL",
                "ACADEMIC YEAR",
                "IS REGISTERED",
                "SPONSOR",
                "EMPLOYER",
                "LAST UPDATED",
            ];

            const worksheet = XLSX.utils.json_to_sheet(this.generatedReport);

            worksheet["A1"] = { v: header[0], t: "s" };
            worksheet["B1"] = { v: header[1], t: "s" };
            worksheet["C1"] = { v: header[2], t: "s" };
            worksheet["D1"] = { v: header[3], t: "s" };
            worksheet["E1"] = { v: header[4], t: "s" };
            worksheet["F1"] = { v: header[5], t: "s" };
            worksheet["G1"] = { v: header[6], t: "s" };
            worksheet["H1"] = { v: header[7], t: "s" };
            worksheet["I1"] = { v: header[8], t: "s" };
            worksheet["J1"] = { v: header[9], t: "s" };
            worksheet["K1"] = { v: header[10], t: "s" };
            worksheet["L1"] = { v: header[11], t: "s" };
            worksheet["M1"] = { v: header[12], t: "s" };
            worksheet["N1"] = { v: header[13], t: "s" };
            worksheet["O1"] = { v: header[14], t: "s" };
            worksheet["P1"] = { v: header[15], t: "s" };
            worksheet["Q1"] = { v: header[16], t: "s" };
            worksheet["R1"] = { v: header[17], t: "s" };

            worksheet["!cols"] = [
                { width: 40 },
                { width: 40 },
                { width: 30 },
                { width: 30 },
                { width: 20 },
                { width: 20 },
                { width: 40 },
                { width: 40 },
                { width: 40 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 40 },
                { width: 40 },
                { width: 40 },
            ];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            XLSX.writeFile(workbook, `${reportName}.xlsx`);
            this.generatedReport = [];
            this.isExportExcel = false;
            this.isApiCallRecurisive = false;
        },
        isRegistered(userId) {
            if (userId) {
                return "Yes";
            } else {
                return "No";
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

body.loading {
    filter: blur(5px);
}

#loading-overlay {
    background-color: rgba(0, 0, 0, 0.25);
}

@responsive {
    .wd-380 {
        width: 380px;
    }

    .ht-242-7 {
        height: 242.7px;
    }

    .wd-216 {
        width: 216px;
    }

    .ht-216 {
        height: 216px;
    }

    .ht-350 {
        height: 350px;
    }

    .ht-430 {
        height: 430px;
    }

    .ht-60-vh {
        height: 60vh;
    }

    .ht-700 {
        height: 700px;
    }
}

.text-map-color {
    color: #09306b;
}

.vue-world-map {
    height: 60vh;
}

@media only screen and (max-width: 1023px) {
    .vue-world-map {
        height: 100%;
    }
}
</style>